<script lang="ts" module>
  import AICardHeaderActionButton, {
    type AICardHeaderActionButtonProps,
  } from './AICardHeaderActionButton.svelte';
  import AICardHeaderActionDropdown, {
    type AICardHeaderActionDropdownProps,
  } from './AICardHeaderActionDropdown.svelte';

  export type AICardHeaderActionProps =
    | AICardHeaderActionButtonProps
    | AICardHeaderActionDropdownProps;
</script>

<script lang="ts">
  let props: AICardHeaderActionProps = $props();
</script>

{#if 'actions' in props}
  <AICardHeaderActionDropdown {...props} />
{:else}
  <AICardHeaderActionButton {...props} />
{/if}
